import { DataItem } from '../../types';
export const documentNameFormat = (data: DataItem) => {
  const resultArray = Object.entries(data);

  return resultArray.map(([key, value]) => `{${key} : ${value}}`).join(', ');
};
